export function toUserMessage(err: unknown): string {
  const fallback = 'Something went wrong. Please try again.';
  if (!err) return fallback;

  // Firebase-style errors often have a 'code' and 'message'
  const e = err as any;
  const code: string | undefined = e?.code || e?.error?.code;
  const msg: string | undefined = e?.message || e?.error?.message;

  // Auth errors
  switch (code) {
    case 'auth/invalid-email':
      return 'That email doesn’t look quite right.';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
      return 'Email or password is incorrect. Please try again.';
    case 'auth/missing-password':
      return 'Please enter your password.';
    case 'auth/missing-email':
      return 'Please enter your email.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Contact support if you think this is a mistake.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a moment and try again.';
    case 'auth/weak-password':
      return 'Password is too weak. Please choose a stronger one.';
    case 'auth/email-already-in-use':
      return 'An account already exists with this email.';
    case 'auth/popup-closed-by-user':
      return 'Sign-in was cancelled.';
    case 'auth/network-request-failed':
      return 'Network error. Check your internet connection.';
  }

  // Firestore/Storage errors
  if (code === 'permission-denied') return 'Access denied. Please sign in again.';
  if (code === 'unavailable') return 'Service temporarily unavailable. Please try again.';

  // Cloudinary or other API messages
  if (msg && /timeout|network/i.test(msg)) return 'Network error. Please try again.';
  if (msg && /permission/i.test(msg)) return 'Access denied.';

  // Generic sanitization: hide provider-specific text
  if (msg) {
    // Remove references to providers
    const cleaned = String(msg).replace(/firebase/gi, '').replace(/cloudinary/gi, '').trim();
    // If message becomes empty or too technical, fall back
    if (!cleaned || cleaned.length < 3 || /auth\//i.test(cleaned)) return fallback;
    return cleaned;
  }

  return fallback;
}